var _circle, _circle2, _circle3, _circle4, _circle5, _polygon, _polygon2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#gradient5)",
    stroke: "url(#border5)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "none",
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 18,
    fill: "none",
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12,
    fill: "none",
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 8,
    fill: "rgba(255,255,255,0.1)",
    stroke: "white",
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,24 38,32 32,40 26,32",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "32,28 36,32 32,36 28,32",
    fill: "rgba(255,255,255,0.2)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 14,
    fill: "white",
    fontFamily: "serif",
    fontSize: 10,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 20,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "2")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 36,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "3")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 50,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "4")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 54,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "5")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 50,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "6")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 36,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "7")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 20,
    fill: "white",
    fontFamily: "serif",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "8")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 37,
    fill: "white",
    fontFamily: "serif",
    fontSize: 12,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "9")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 1,
    fill: "rgba(255,255,255,0.8)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 32,
    r: 1,
    fill: "rgba(255,255,255,0.8)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 56,
    r: 1,
    fill: "rgba(255,255,255,0.8)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 1,
    fill: "rgba(255,255,255,0.8)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#a29bfe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6c5ce7",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "border5",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffeaa7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fdcb6e",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconSmall);
export default __webpack_public_path__ + "static/media/app-icon-small.1f6ccab8d0c63df18f5fa7f5cb8e7cbb.svg";
export { ForwardRef as ReactComponent };